import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormBuilder, FieldArray, Validators} from 'react-reactive-form';
import renderer from './renderers';
import validation from '../../../utils/validation';

class IdentifiersEditControl extends Component {
    constructor(props){
        super(props);

        this.addNewItem = this.addNewItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.onItemChanged = this.onItemChanged.bind(this);
    };

    static initArray(items, form) {
        var result = [];
        if (items) {
            for (var item of items) {
                var ni = {
                    type: 'type' in item ? item.type : '',
                    value: 'value' in item ? item.value : '',
                    primary: 'primary' in item ? item.primary : false,
                    current: 'current' in item ? item.current : false,
                    startDate: ['startDate' in item ? item.startDate : '', [Validators.pattern(validation.datePattern)]],
                    endDate: ['endDate' in item ? item.endDate : '', [Validators.pattern(validation.datePattern)]]
                }
                result.push(FormBuilder.group(ni));
            }
        }
        return result;
    }

    onItemChanged(value, fieldName, arrayIndex) {
        var group = this.props.form.get(this.props.name).controls[arrayIndex];
        if (group && fieldName == 'endDate') {
            if (value.length > 0) {
                group.get('current').setValue(false);
                group.get('current').disable();
            } else {
                group.get('current').enable();
            }
        }
    }

    addNewItem() {
        console.log('Adding to field => ', this.props.name);
        const arr = this.props.form.get(this.props.name);

        arr.push(FormBuilder.group({
            type: '',
            value: '',
            primary: true,
            current: true,
            startDate: ['', Validators.pattern(validation.datePattern)],
            endDate: ['', Validators.pattern(validation.datePattern)]
        }));
    }

    removeItem(index) {
        console.log('Removing from field => ', this.props.name, ' index => ', index);
        const control = this.props.form.get(this.props.name);
        control.removeAt(index);
    }

    render() {
        return (
            <FieldArray name={this.props.name} 
                render={renderer.identifiersArray} 
                meta={{
                    label: this.props.label,
                    addLabel: this.props.addLabel,
                    onAdd: () => {this.addNewItem()},
                    onRemove: (index) => {this.removeItem(index)},
                    onChange: (val, field, index) => {this.onItemChanged(val, field, index)},
                    form: this.props.form
                }}
            />
        );
    };
}

IdentifiersEditControl.propTypes = {
    name: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    label: PropTypes.string,
    addLabel: PropTypes.string
};

export default IdentifiersEditControl;

